const tabs1 = [
  {
    name: '南管音樂',
    autor: '',
    path: 'videoRecord_1',
  },
  {
    name: '北管音樂',
    autor: '',
    path: 'videoRecord_2',
  },
  {
    name: '福佬歌謠',
    autor: '',
    path: 'videoRecord_3',
  },
  {
    name: '客家音樂',
    autor: '',
    path: 'videoRecord_4',
  },
  {
    name: '原住民音樂－賽夏族、阿美族、卑南族、雅美族、太魯閣族、撒奇萊雅族',
    autor: '',
    path: 'videoRecord_5',
  },
  {
    name: '原住民音樂－泰雅族、鄒族、邵族、布農族、噶瑪蘭族、賽德克族',
    autor: '',
    path: 'videoRecord_6',
  },
  {
    name: '原住民音樂－排灣族、魯凱族、卡那卡那富族、拉阿魯哇族、平埔族',
    autor: '',
    path: 'videoRecord_7',
  },
  // {
  //   name: '原住民音樂－邵族、布農族、噶瑪蘭族、賽德克族',
  //   autor: '',
  //   path: 'videoRecord_8',
  // },
  {
    name: '佛教、釋教音樂',
    autor: '',
    path: 'videoRecord_9',
  },
  {
    name: '道教、法教音樂',
    autor: '',
    path: 'videoRecord_10',
  },
];
const tabs2 = [
  {
    name: '國樂',
    autor: '',
    path: 'videoRecord_11',
  },
  {
    name: '西樂及混合編制',
    autor: '',
    path: 'videoRecord_12',
  },
];
const tabs3 = [
  {
    name: '流行音樂',
    autor: '',
    path: 'videoRecord_13',
  },
];
const tabs4 = [
  {
    name: '跨界音樂與其他',
    autor: '',
    path: 'videoRecord_14',
  },
];
export {
  tabs1, tabs2, tabs3, tabs4,
};
